const translations = {
  CONTACT_DEALER: {
    en: 'Contact this dealer',
    fr: 'Contacter ce concessionnaire',
    es: 'Contacte con este distribuidor',
    it: 'Contatta questo concessionario',
  },
  FORM_ERROR_MANDATORY: {
    en: 'This field is mandatory',
    fr: 'Ce champ est obligatoire',
    es: 'Este campo es obligatorio',
    it: 'Questo campo è obbligatorio',
  },
  FORM_ERROR_GLOBAL: {
    en: 'Incorrect field',
    fr: 'Champ incorrect',
    es: 'Campeón incorrecto',
    it: 'Campo non corretto',
  },
  FORM_ERROR_MAIL: {
    en: 'Incorrect email format',
    fr: 'Format d\'email incorrect',
    es: 'Formato incorrecto del correo electrónico',
    it: 'Formato email non corretto',
  },
  FORM_ERROR_TEL: {
    en: 'Incorrect phone format',
    fr: 'Format de téléphone incorrect',
    es: 'Formato de teléfono incorrecto',
    it: 'Formato del telefono non corretto',
  },
  FORM_ERROR_DATE: {
    en: 'Incorrect date format',
    fr: 'Format de date incorrect',
    es: 'Formato de fecha incorrecto',
    it: 'Formato della data non corretto',
  },
  FORM_ERROR_PASSWORD: {
    en: 'Invalid password format',
    fr: 'Format du mot de passe invalide',
    es: 'Formato de contraseña incorrecto',
    it: 'Formato della password non valido',
  },
  FORM_ERROR_PASSWORD2: {
    en: 'Both passwords must be identical',
    fr: 'Les deux mots de passe doivent être identiques',
    es: 'Las dos contraseñas deben ser idénticas',
    it: 'Le due password devono essere identiche',
  },
  FORM_ERROR_RADIO: {
    en: 'Please select a choice',
    fr: 'Veuillez sélectionner un choix',
    es: 'Seleccione una opción',
    it: 'Seleziona una scelta',
  },
  FORM_ERROR_HIN: {
    en: 'Format expected: FRFPA12345A123 or if HIN starts with “2511017” it must contain 13 digits',
    fr: 'Format attendu : FRFPA12345A123 ou si HIN commençant par “2511017” doit contenir 13 chiffres',
    es: 'Formato esperado: FRFPA12345A123 o si el HIN comienza por “2511017”, debe contener 13 dígitos',
    it: 'Formato previsto: FRFPA12345A123 oppure, se l’HIN inizia con “2511017”, deve contenere 13 cifre',
  },
  FORM_ERROR_HIN_2511017: {
    en: 'A HIN starting with "2511017" must contain exactly 13 digits.',
    fr: 'Le HIN commençant par "2511017" doit contenir 13 chiffres.',
    es: 'Un HIN que empiece por "2511017" debe contener exactamente 13 dígitos.',
    it: 'Un HIN che inizia con "2511017" deve contenere esattamente 13 cifre.',
  },
  FORM_ERROR_SENDING: {
    en: 'Submission error',
    fr: 'Erreur lors de la soumission',
    es: 'Error de envío',
    it: 'Errore durante l\'invio',
  },
  FORM_SUCCESS_SALON: {
    en: 'The request has been sent.',
    fr: 'La demande a bien été envoyée.',
    es: 'La solicitud ha sido enviada.',
    it: 'La richiesta è stata inviata.',
  },
  FORM_SUCCESS_NEWSLETTER: {
    en: 'Thank you for your subscription.',
    fr: 'Merci pour votre inscription.',
    es: 'Gracias por inscribirse',
    it: 'Grazie per la tua iscrizione.',
  },
  FORM_SUCCESS_CONTACT_INFO: {
    en: 'Thank you for your message.',
    fr: 'Merci pour votre message.',
    es: 'Gracias por su mensaje.',
    it: 'Grazie per il tuo messaggio.',
  },
  INPUT_FILE_EMPTY: {
    en: 'No files selected',
    fr: 'Aucun fichier choisi',
    es: 'No hay archivos seleccionados',
    it: 'Nessun file selezionato',
  },
  NEWSROOM_PROGRESS: {
    en: 'You\'ve seen *current* out of *total* pieces of content',
    fr: 'Vous avez vu *current* contenus sur *total*',
    es: 'Ha visto *current* de cada *total* contenidos',
    it: 'Hai visto *current* contenuti su *total*',
  },
  OCCASIONS_PROGRESS: {
    en: 'You\'ve seen *current* out of *total* offers',
    fr: 'Vous avez vu *current* offres sur *total*',
    es: 'Ha visto *current* de cada *total* ofertas',
    it: 'Hai visto *current* offerte su *total*',
  },
  OFFERS_PROGRESS: {
    en: 'You\'ve seen *current* out of *total* jobs',
    fr: 'Vous avez vu *current* postes sur *total*',
    es: 'Ha visto *current* de cada *total* trabajos',
    it: 'Hai visto *current* offerte su *total*',
  },
  OFFERS_NO_RESULT: {
    en: 'There are no offers matching your search. Please try again with other criteria.',
    fr: 'Aucune offre ne correspond à votre recherche. Veuillez réessayer avec d\'autres critères.',
    es: 'No hay ofertas que coincidan con su búsqueda. Vuelve a intentarlo con otros criterios.',
    it: 'Non ci sono offerte corrispondenti alla tua ricerca. Riprova con altri criteri.',
  },
  FORM_COUNTRY: {
    en: 'Choose your country',
    fr: 'Choisissez un pays',
    es: 'Elija un país',
    it: 'Scegli il tuo paese',
  },
  FORM_STATE: {
    en: 'Choose your home port',
    fr: "Choisissez votre port d’attache",
    es: 'Elija su puerto base',
    it: 'Scegli il tuo porto base',
  },
  PAGE_NAV_PRODUCT_VIDEO_WRAP: {en: 'Video', fr: 'Vidéos', es: 'Video', it: 'Video'},
  PAGE_NAV_PRODUCT_FEATURES: {en: 'Specifications', fr: 'Spécifications', es: 'Especificación', it: 'Specifiche'},
  PAGE_NAV_PRODUCT_SPACES: {en: 'Photos', fr: 'Photos', es: 'Foto', it: 'Foto'},
  PAGE_NAV_PRODUCT_MILLESIME: {en: 'Millesime', fr: 'Millésime', es: 'Millesime', it: 'Millesime'},
  PAGE_NAV_PRODUCT_VIRTUAL_TOUR: {en: '360° Tour', fr: 'Visite 360°', es: '360° visita', it: 'Tour 360°'},
  PAGE_NAV_PRODUCT_CONFIG_3D: {en: '3D Configurator', fr: 'Configurateur 3D', es: 'Configurador 3D', it: 'Configuratore 3D'},
  PAGE_NAV_ODSEA_SOLUTIONS: {en: 'Assets', fr: 'Atout ODSea+', es: 'Ventajas', it: 'Vantaggi'},
  PAGE_NAV_ODSEA_RENEWABLE_ENERGIES: {en: 'Renewable energies', fr: 'Energies renouvelables', es: 'Energías renovables', it: 'Energie rinnovabili'},
  PAGE_NAV_ODSEA_SCRIPTS: {en: 'Cruising scenarios', fr: 'Scénarios de croisières', es: 'Escenarios de crucero', it: 'Scenari di crociera'},
  PAGE_NAV_ODSEA_OTHER_PRODUCTS: {en: 'Hybrid catamarans', fr: 'Catamarans hybrides', es: 'Catamaranes híbridos', it: 'Catamarani ibridi'},
  PAGE_NAV_CARREERS_VIDEOS: {fr: 'Vidéos Métiers', en: 'Career videos', es: 'Videos de profesiones', it: 'Video professioni'},
  PAGE_NAV_CARREERS_OFFRES: {fr: 'Nos offres', en: 'Our job offers', es: 'Nuestras ofertas', it: 'Le nostre offerte'},
  PAGE_NAV_CARREERS_FORMATIONS: {fr: 'Nos formations ITN', en: 'Our ITN training programs', es: 'Nuestras formaciones ITN', it: 'Le nostre formazioni ITN'}
}

export default (key, lang) => {
  const locale = lang || document.querySelector('html').getAttribute('lang')

  const body = document.querySelector('body')
  const siteId = body && body.classList.contains('site--dufour') ? 4 : null

  if (key === 'PAGE_NAV_ODSEA_OTHER_PRODUCTS' && siteId === 4) {
    const dufourTranslations = {
      en: 'Hybrid sailors',
      fr: 'Voiliers hybrides',
      es: 'Híbridos veleros',
    }

    if (dufourTranslations[locale]) {
      return dufourTranslations[locale]
    }
  }

  const string =
    translations[key] && translations[key][locale]
      ? translations[key][locale]
      : 'missing translation'
  return string
}
